// /* eslint-disable react/prop-types */
// import React from "react";
// import SoftBox from "components/SoftBox";
// import SoftTypography from "components/SoftTypography";
// import { Tabs, Tab, IconButton } from "@mui/material";
// import Icon from "@mui/material/Icon";
// import { useNavigate } from "react-router-dom";
// import { useSoftUIController, setMiniSidenav } from "context";

// const MainHeader = ({
//   activeTopTab,
//   setActiveTopTab,
//   activeDataTab,
//   setActiveDataTab,
// }) => {
//   const navigate = useNavigate();
//   const [controller, dispatch] = useSoftUIController();
//   const { miniSidenav } = controller;

//   const topTabs = ["My Data", "Team"];
//   const subTabs = ["Pre Payment", "Payroll", "Expenses", "Incentive", "Other"];

//   const handleTopTabChange = (tab) => {
//     setActiveTopTab(tab);
//     if (tab === "Team") {
//       setActiveDataTab("Team List");
//     } else if (tab === "My Data") {
//       setActiveDataTab("Pre Payment");
//     }
//   };

//   const handleSubTabChange = (event, newValue) => {
//     setActiveDataTab(newValue);
//   };

//   const handleMiniSidenavToggle = () => {
//     setMiniSidenav(dispatch, !miniSidenav);
//   };

//   return (
//     <SoftBox>
//       {/* Top Header Bar */}
//       <SoftBox
//         display="flex"
//         alignItems="center"
//         px={3}
//         py={2}
//         sx={{ backgroundColor: "#2C3E75" }}
//         justifyContent="space-between"
//       >
//         {/* Top Tabs */}
//         <SoftBox display="flex" gap={3}>
//           {topTabs.map((tab) => (
//             <SoftTypography
//               key={tab}
//               onClick={() => handleTopTabChange(tab)}
//               variant="h6"
//               fontWeight="bold"
//               sx={{
//                 color: activeTopTab === tab ? "#fff" : "#c0c0c0",
//                 borderBottom:
//                   activeTopTab === tab ? "2px solid #00c2ff" : "none",
//                 cursor: "pointer",
//                 transition: "all 0.2s ease-in-out",
//               }}
//             >
//               {tab}
//             </SoftTypography>
//           ))}
//         </SoftBox>

//         {/* Mini Sidenav Toggle Icon */}
//         <IconButton
//           size="small"
//           onClick={handleMiniSidenavToggle}
//           sx={{ color: "#fff" }}
//         >
//           <Icon>{miniSidenav ? "menu_open" : "menu"}</Icon>
//         </IconButton>
//       </SoftBox>

//       {/* Sub Tabs */}
//       {activeTopTab === "My Data" && (
//         <SoftBox
//           sx={{ backgroundColor: "#fff", borderBottom: "1px solid #eee" }}
//           px={3}
//         >
//           <Tabs
//             value={activeDataTab}
//             onChange={handleSubTabChange}
//             textColor="primary"
//             sx={{ fontSize: "12px", minHeight: "38px" }}
//           >
//             {subTabs.map((tab) => (
//               <Tab
//                 key={tab}
//                 label={
//                   <SoftTypography fontSize="0.75rem" fontWeight="medium">
//                     {tab}
//                   </SoftTypography>
//                 }
//                 value={tab}
//                 sx={{
//                   textTransform: "none",
//                   minHeight: "32px",
//                   padding: "4px 12px",
//                   marginRight: 1,
//                   fontSize: "0.95rem",
//                   "&.Mui-selected": {
//                     color: "#000",
//                     borderBottom: "2px solid #00c2ff",
//                   },
//                 }}
//               />
//             ))}
//           </Tabs>
//         </SoftBox>
//       )}
//     </SoftBox>
//   );
// };

// export default MainHeader;


/* eslint-disable react/prop-types */
import React from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Tabs, Tab, IconButton } from "@mui/material";
import Icon from "@mui/material/Icon";
import { useNavigate } from "react-router-dom";
import { useSoftUIController, setMiniSidenav } from "context";

const MainHeader = ({
  activeTopTab,
  setActiveTopTab,
  activeDataTab,
  setActiveDataTab,
}) => {
  const navigate = useNavigate();
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav } = controller;

  const topTabs = ["My Data", "Team", "Salary Manual"];
  const subTabs = ["Pre Payment", "Payroll", "Expenses", "Incentive", "Other"];

  const handleTopTabChange = (tab) => {
    setActiveTopTab(tab);
    if (tab === "Team") {
      setActiveDataTab("Team List");
    } else if (tab === "My Data") {
      setActiveDataTab("Pre Payment");
    } else if (tab === "Salary Manual") {
      setActiveDataTab("Salary Manual");
    }
  };

  const handleSubTabChange = (event, newValue) => {
    setActiveDataTab(newValue);
  };

  const handleMiniSidenavToggle = () => {
    setMiniSidenav(dispatch, !miniSidenav);
  };

  return (
    <SoftBox>
      {/* Top Header Bar */}
      <SoftBox
        display="flex"
        alignItems="center"
        px={3}
        py={2}
        sx={{ backgroundColor: "#2C3E75" }}
        justifyContent="space-between"
      >
        {/* Top Tabs */}
        <SoftBox display="flex" gap={3}>
          {topTabs.map((tab) => (
            <SoftTypography
              key={tab}
              onClick={() => handleTopTabChange(tab)}
              variant="h6"
              fontWeight="bold"
              sx={{
                color: activeTopTab === tab ? "#fff" : "#c0c0c0",
                borderBottom:
                  activeTopTab === tab ? "2px solid #00c2ff" : "none",
                cursor: "pointer",
                transition: "all 0.2s ease-in-out",
                pb: 0.5,
              }}
            >
              {tab}
            </SoftTypography>
          ))}
        </SoftBox>

        {/* Mini Sidenav Toggle Icon */}
        <IconButton
          size="small"
          onClick={handleMiniSidenavToggle}
          sx={{ color: "#fff" }}
        >
          <Icon>{miniSidenav ? "menu_open" : "menu"}</Icon>
        </IconButton>
      </SoftBox>

      {/* Sub Tabs - Only show for "My Data" tab */}
      {activeTopTab === "My Data" && (
        <SoftBox
          sx={{ backgroundColor: "#fff", borderBottom: "1px solid #eee" }}
          px={3}
        >
          <Tabs
            value={activeDataTab}
            onChange={handleSubTabChange}
            textColor="primary"
            sx={{ fontSize: "12px", minHeight: "38px" }}
          >
            {subTabs.map((tab) => (
              <Tab
                key={tab}
                label={
                  <SoftTypography fontSize="0.75rem" fontWeight="medium">
                    {tab}
                  </SoftTypography>
                }
                value={tab}
                sx={{
                  textTransform: "none",
                  minHeight: "32px",
                  padding: "4px 12px",
                  marginRight: 1,
                  fontSize: "0.95rem",
                  "&.Mui-selected": {
                    color: "#000",
                    borderBottom: "2px solid #00c2ff",
                  },
                }}
              />
            ))}
          </Tabs>
        </SoftBox>
      )}

      {/* Optional: Show different sub tabs for "Salary Manual" if needed */}
      {/* {activeTopTab === "Salary Manual" && (
        <SoftBox
          sx={{ backgroundColor: "#fff", borderBottom: "1px solid #eee" }}
          px={3}
        >
          <Tabs
            value={activeDataTab}
            onChange={handleSubTabChange}
            textColor="primary"
            sx={{ fontSize: "12px", minHeight: "38px" }}
          >
            <Tab
              label={
                <SoftTypography fontSize="0.75rem" fontWeight="medium">
                  Upload & View
                </SoftTypography>
              }
              value="Salary Manual"
              sx={{
                textTransform: "none",
                minHeight: "32px",
                padding: "4px 12px",
                marginRight: 1,
                fontSize: "0.95rem",
                "&.Mui-selected": {
                  color: "#000",
                  borderBottom: "2px solid #00c2ff",
                },
              }}
            />
          </Tabs>
        </SoftBox>
      )} */}
    </SoftBox>
  );
};

export default MainHeader;